<template>
	<div class="my-earning-list__grid-container">

		<template v-if="loadingEarnData">
			<v-skeleton-loader :elevation="4" type="list-item-avatar-three-line" v-for="n in 20" :key="n"
				color="var(--v-skeleton-loader-color)">
			</v-skeleton-loader>
		</template>


		<template v-else>
			<div class="my-earning-list__daily-earnings" v-for="entry in earnData" :key="entry[0]">

				<div class="my-earning-list__date"
					v-if="new Date(entry[0]).toDateString() === new Date().toDateString()">
					Today
				</div>


				<div class="my-earning-list__date" v-else-if="new Date(entry[0]).toDateString() ===
					new Date(new Date().setDate(new Date().getDate() - 1)).toDateString()">
					Yesterday
				</div>


				<div class="my-earning-list__date" v-else>
					{{
						new Date(entry[0]).toLocaleDateString("en-US", {
							month: "short", day: "numeric", year: "numeric"
						})
					}}
				</div>

				<div class="my-earning-list__earnings">
					<div v-for="data in entry[1]" :key="data.id">
						<MyEarningTile :earnDataId="data.id" @click="tileClicked(data)"></MyEarningTile>
					</div>
				</div>
			</div>
		</template>
	</div>

	<EmptyList class="mx-auto mt-4" v-if="earnData.length === 0 && !loadingEarnData">
		<template v-slot:title>
			Sorry, you haven't referred anyone yet.
		</template>
	</EmptyList>


	<Pagination 
		:model-value="pageNumber"
		@update:model-value="(value) => pageNumber = value"
		:length="pageLength" 
		:total-visible="totalVisible"
	/>


	<MyEarningDialog></MyEarningDialog>
</template>



<script setup>

import { computed, ref, provide } from "vue";
import { usePagination } from "@/composables/usePagination";
import { UserActivityStore } from "@/store/UserActivityStore";
import { sortMapEntriesDescending, groupItemsByDate } from "@/utils/utils";

import EmptyList from "@/components/Common/Empty-List.vue";
import Pagination from "@/components/Common/Pagination.vue";
import MyEarningTile from "@/components/Tiles/Earn/MyEarning-Tile.vue";
import MyEarningDialog from "@/components/Earn/MyEarning/MyEarning-Dialog.vue";


let openDialog = ref(false);
provide("openDialog", openDialog);
const inHouseTasksStore = UserActivityStore();


const loadingEarnData = computed(() => inHouseTasksStore.loadingEarnData);

// Use the pagination composable to handle pagination logic
const { pageNumber, pageLength, totalVisible } = usePagination({
	store: inHouseTasksStore,
	getTotalPages: (store) => store.earnDataPaging.totalPages,
	getCurrentPage: (store) => store.earnDataPaging.page,
	setPage: (store, page) => store.setPage(page),
	fetchData: async (store) => await store.getEarnData()
});

const earnData = computed(() => {
	const unsortedData = inHouseTasksStore.earnData;

	const sectionMap = groupItemsByDate(unsortedData);

	const sortedData = sortMapEntriesDescending(sectionMap);
	return sortedData;
});

const tileClicked = () => {
	openDialog.value = true;
}

</script>



<style scoped lang="scss">
@use "@/assets/scss/button-mixins" as button-mixins;
@use "@/assets/scss/components/Earn/my-earnings-list" as my-earnings-list;
</style>